import { ComponentProps } from 'react';
import { withFocusableSelect } from '../components/with-focusable-select';
import { ControlledMultiSelectFieldEditorPopover } from './controlled-multi-select-field-editor-popover';

export const MultiSelectFieldEditorPopover = withFocusableSelect<
  number[],
  ComponentProps<typeof ControlledMultiSelectFieldEditorPopover>
>(ControlledMultiSelectFieldEditorPopover);
